import { ReactNode, useState } from 'react'

import PhatDropdown from 'components/formElements/PhatDropdown'

import styles from './bracketDropdown.module.scss'

type Props = {
  value?: number | null
  onChange: (values: number | null) => void
  header?: ReactNode
  className?: string
  disabled?: boolean
  placeholder?: string
  includeDisclaimer?: boolean
  overrideUnsetLabel?: string
}

const BracketDropdown = ({
  value,
  onChange,
  header,
  className,
  disabled = false,
  placeholder,
  includeDisclaimer = false,
  overrideUnsetLabel,
}: Props) => {
  const [selectedValue, setSelectedValue] = useState(value ?? null)

  const handleChange = (selectedValue: number | null) => {
    setSelectedValue(selectedValue)
    onChange(selectedValue)
  }

  return (
    <>
      <PhatDropdown
        placeholder={placeholder || 'Format'}
        options={[
          { label: overrideUnsetLabel || 'Any', id: 'null', onClick: () => handleChange(null) },
          { label: '1 - Exhibition', id: '1', onClick: () => handleChange(1) },
          { label: '2 - Core', id: '2', onClick: () => handleChange(2) },
          { label: '3 - Upgraded', id: '3', onClick: () => handleChange(3) },
          { label: '4 - Optimized', id: '4', onClick: () => handleChange(4) },
          { label: '5 - cEDH', id: '5', onClick: () => handleChange(5) },
        ]}
        value={`${value ?? selectedValue}`}
        header={header}
        className={`${styles.fullWidth} ${className}`}
        triggerWrapperClassName={styles.fullWidth}
        disabled={disabled}
      />

      {includeDisclaimer && (
        <label className={styles.disclaimer}>
          **The Commander Bracket of a deck is NOT a strict power ranking of a deck. It is a tool for you to better
          communicate what is in your deck, and what it is trying to do with other players.
        </label>
      )}
    </>
  )
}

export default BracketDropdown
